import intl from 'react-intl-universal';

export const validationExports = (
  contextModal,
  filter,
  isMasterDataEnhancementsEnabled = false
) => {
  switch (contextModal) {
    case "masterData":
      return isMasterDataEnhancementsEnabled
        ? validationsToExportMasterDataV2(filter)
        : validationsToExportMasterData(filter);
    case "planningBottles":
      return validationsToExportPlanningBottles(filter);
    default:
      return null;
  }
};

const validationsToExportMasterData = (filter) => {
  let validation;
  if (filter?.materialGroup?.length <= 0) {
    validation = intl.get('exportImportModal.masterData.formValidation.material-group');
  }
  return validation;
}

const validationsToExportMasterDataV2 = (filter) => {
  const hasFilter =
    filter?.materialGroup?.length > 0 ||
    filter?.labeledFamily?.length > 0 ||
    filter?.center?.length > 0 ||
    filter?.countries?.length > 0;

  if (!hasFilter) {
    return intl.get("exportImportModal.masterData.formValidation.required-filter");
  }
};

const validationsToExportPlanningBottles = (filter) => {
  let validation;
  if (filter?.supplier?.length <= 0) {
    validation = intl.get('manual-suggestion-order-form.formValidation.supplier')
  }
  return validation;
}